<template>
  <div style="margin-top: -2rem;">
    <transition name="fade">
      <div class="d-flex flex-wrap" v-if="view == 'grid'">
        <template v-if="page === 1">
          <book-thumbnail
            :imgCover="comboItem.imgCover"
            :bookTitle="comboItem.bookTitle"
            :bookDesc="comboItem.bookDesc"
            :bookId="comboItem.bookId"
            :bookPrice="comboItem.bookPrice"
            :bookRegular="comboItem.regularCost"
            :bookStock="comboItem.bookStock"
            :size="comboItem.size"
            :promo="null"
            v-for="comboItem in combos"
            :key="'combo-' + comboItem.id"
            :showPrices="showPrices"
            :escombo="true"
          />
        </template>
        <book-thumbnail
          :imgCover="bookItem.imgCover"
          :bookTitle="bookItem.bookTitle"
          :bookDesc="bookItem.bookDesc"
          :bookId="bookItem.bookId"
          :bookPrice="bookItem.bookPrice"
          :bookRegular="bookItem.regularCost"
          :bookStock="bookItem.bookStock"
          :size="bookItem.size"
          :promo="bookItem.promo"
          v-for="bookItem in items"
          :key="bookItem.id"
          :showPrices="showPrices"
        />        
      </div>
      <b-list-group flush v-else>
        <template v-if="page === 1">
          <b-list-group-item class="d-flex" v-for="comboItem in combos"
          :key="'combo-' + comboItem.id">
            <book-thumbnail
              :imgCover="comboItem.imgCover"
              :bookTitle="comboItem.bookTitle"
              :bookDesc="comboItem.bookDesc"
              :bookId="comboItem.bookId"
              :bookPrice="comboItem.bookPrice"
              :bookRegular="comboItem.regularCost"
              :bookStock="comboItem.bookStock"
              :size="comboItem.size"
              :promo="null"
              :showPrices="showPrices"
              view="long"
              :escombo="true"
            />
          </b-list-group-item>
        </template>
        <b-list-group-item class="d-flex" v-for="bookItem in items"
          :key="bookItem.id">
            <book-thumbnail
            :imgCover="bookItem.imgCover"
            :bookTitle="bookItem.bookTitle"
            :bookDesc="bookItem.bookDesc"
            :bookId="bookItem.bookId"
            :bookPrice="bookItem.bookPrice"
            :bookRegular="bookItem.regularCost"
            :bookStock="bookItem.bookStock"
            :size="bookItem.size"
            :showPrices="showPrices"
            :promo="bookItem.promo"
            view="long"
          />
        </b-list-group-item>
      </b-list-group>
    </transition>
    <div class="text-center mt-5" v-if="!nopagination && maxpage > 1">
      <div class="book-pager">
        <b-link href="" @click="changePage(-1)">
          <b-icon icon="chevron-left" />
        </b-link>
        {{ page }} de {{ maxpage }}
        <b-link href="" @click="changePage(1)">
          <b-icon icon="chevron-right" />
        </b-link>
      </div>
    </div>
    <book-modal :bookData="bookModalData" :escombo="modalCombo" :modalid="_uid" />
  </div>
</template>
<script>
import BookThumbnail from "@/components/BookThumbnail.vue";
import BookModal from "@/components/BookModal.vue";

export default {
  components: {
    BookThumbnail,
    BookModal
  },
  data() {
    return {
      localpage: 1,
      bookModalData: {},
      modalCombo: false
    };
  },
  props: {
    items: Array,
    nopagination: Boolean,
    showPrices: Boolean,
    maxpage: Number,
    view: String,
    page: Number,
    combos: Array
  },
  mounted() {
    this.localpage = this.page;
  },
  methods: {
    changePage: function(direction) {
      this.localpage += direction;
      if (this.localpage < 1) {
        this.localpage = this.maxpage;
      } else if (this.localpage > this.maxpage) {
        this.localpage = 1;
      }
      this.$emit("change", this.localpage);
    },
    showModal: function(itemId, combo = false) {
      let modalData = {};
      if (combo) {
        this.combos.forEach(function(element) {
          if (element.bookId === itemId) {
            modalData = element;
          }
        });
      } else {
        this.items.forEach(function(element) {
          if (element.bookId === itemId) {
            modalData = element;
          }
        });
      }
      this.modalCombo = combo
      this.bookModalData = modalData;
      this.$bvModal.show("bookModal_" + this._uid);
    }
  }
};
</script>
